import { render } from "./orderSetup.vue?vue&type=template&id=3c5114bb&scoped=true"
import script from "./orderSetup.vue?vue&type=script&lang=js"
export * from "./orderSetup.vue?vue&type=script&lang=js"

import "./orderSetup.vue?vue&type=style&index=0&id=3c5114bb&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5114bb"]])

export default __exports__